import { Outlet } from "react-router-dom";

import { useAppSelector } from "@/hooks/redux";
import { Unauthorized } from "@/pages/System/Unauthorized";

interface RoleGuardProps {
    allowedRoles?: string[];
}

export const RoleGuard = ({ allowedRoles }: RoleGuardProps) => {
    const { role } = useAppSelector((state) => state.user);

    if (allowedRoles && role && !allowedRoles.includes(role)) {
        return <Unauthorized />;
    }

    return <Outlet />;
};
